export default __webpack_public_path__ + "static/media/AdminSupport.2c6dc486.png";